/**
 * @file AI 助理数据看板路由
 * @author izzieyspu
 */

import React from 'react';
import { Redirect } from 'react-router-dom';

import History from '../history';
import Entry from '../entry';
import AIDashboard from '../../ai-dashboard';

export const routes = [
  {
    path: '/analysis/ai-dashboard/:id',
    component: AIDashboard,
    exact: true,

  },
  {
    key: 'history',
    path: '/analysis/ai-agent/history',
    component: History,
    exact: true,
  },
  {
    key: 'new',
    path: '/analysis/ai-agent/new',
    component: ({ location }: any) => (
      <Redirect to={{ pathname: '/analysis/ai-agent', search: location.search }} />
    ),
    exact: true,
  },
  {
    key: 'home',
    path: '/analysis/ai-agent/:sessionId?',
    component: Entry,
    exact: true,
  },
];

export const getAIPageModule = (url: string) => {
  if (url.startsWith('/analysis/ai-dashboard')) {
    return ['AI 数据看板-已保存看板'];
  }
  if (url === '/analysis/ai-agent/history') {
    return ['AI 数据看板-历史记录'];
  }
  if (url === '/analysis/ai-agent') {
    return ['AI 数据看板-新建对话'];
  }
  if (url.startsWith('/analysis/ai-agent/')) {
    return ['AI 数据看板-历史对话'];
  }
  return [];
};

const matchAiAgentUrl = (url: string) => url === '/analysis/ai-agent' || url.startsWith('/analysis/ai-agent/');

export const NAV_CONFIG: any = [
  {
    label: 'AI 助理',
    key: 'ai-agent-analysis-entry',
    iconClassName: 'icon-menu-nav icon-nav-ai-agent',
    'data-report-global': 'menu-nav.ai-agent-analysis-entry',
    data: [
      {
        label: 'AI 数据看板',
        key: 'ai-agent-analysis-home',
        url: '/analysis/ai-agent/new',
        match: matchAiAgentUrl,
        'data-report-global': 'menu-nav.ai-agent-analysis-home',
      },
    ],
  },
];
